var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12559 7.50011L0.284773 1.65911C-0.0953379 1.27918 -0.0953379 0.664882 0.284773 0.28495C0.664705 -0.0949832 1.279 -0.0949832 1.65894 0.28495L7.49993 6.12595L13.3408 0.28495C13.7209 -0.0949832 14.335 -0.0949832 14.7149 0.28495C15.095 0.664882 15.095 1.27918 14.7149 1.65911L8.8741 7.50011L14.7149 13.3411C15.095 13.721 15.095 14.3353 14.7149 14.7153C14.5256 14.9048 14.2766 15 14.0278 15C13.7791 15 13.5303 14.9048 13.3408 14.7153L7.49993 8.87428L1.65894 14.7153C1.46942 14.9048 1.22064 15 0.971855 15C0.723075 15 0.474295 14.9048 0.284773 14.7153C-0.0953379 14.3353 -0.0953379 13.721 0.284773 13.3411L6.12559 7.50011Z",
    fill: "#9B6BDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1773035a14309480d0fdae09a89ebe83.svg";
export { ForwardRef as ReactComponent };